




























































import { Component, Vue } from 'vue-property-decorator'
import dealModule from '@/store/deal'
import { TextFieldRules } from '@/utils/enums'
import { Deal } from '../../types/Deal'

@Component({
  name: 'OnlineRedemption'
})
class OnlineRedemption extends Vue {
  private orderNumber = ''
  private deal = ''
  private rules = TextFieldRules

  private get deals() {
    return dealModule.redemptions
  }

  private formattedName(deal: Deal): string {
    return `${deal.name} (${deal.company.name})`
  }

  private get isValidForm(): boolean {
    return this.orderNumber.trim().length > 0 && this.deal.length > 0
  }

  private async created(): Promise<void> {
    await dealModule.fetchRedemptions()
  }

  private async redeemDeal(): Promise<void> {
    dealModule.createRedemption({
      orderNumber: this.orderNumber,
      deal: this.deal
    })
    document.dispatchEvent(new Event('close-redeem'))
  }
}

export default OnlineRedemption
